export default class GlobalNavigation extends HTMLDivElement {

    isAnimating = false;

    connectedCallback() {
        this.opener.addEventListener("click", this.toggle);
        this.addEventListener("navigate", this.handleNavigate, true);
        document.documentElement.addEventListener("keyup", this.handleKeyup, true);
        document.documentElement.addEventListener("click", this.handleClickOutside, true);
        this.body.addEventListener("animationend", this.handleAnimationend, true);
    }

    disconnectedCallback() {
        this.opener.removeEventListener("click", this.show);
        this.removeEventListener("navigate", this.handleNavigate, true);
        document.documentElement.removeEventListener("keyup", this.handleKeyup, true);
        document.documentElement.removeEventListener("click", this.handleClickOutside, true);
        this.body.removeEventListener("animationend", this.handleAnimationend);
    }

    handleAnimationend = (e) => {
        const body = this.body;

        let prevCurrentPane = body.querySelector('.current');

        prevCurrentPane.classList.remove('current');
        prevCurrentPane.inert = true;

        let currentPane = body.querySelector('.slide-from-left,.slide-from-right');

        currentPane.classList.add('current');
        currentPane.classList.remove('slide-from-left', 'slide-from-right');

        currentPane.inert = false;
        currentPane.focus();

        this.isAnimating = false;
    }

    handleNavigate = (e) => {
        const { pageId, isChild } = e.detail;
        const className = isChild ? "slide-from-right" : "slide-from-left";
        let nav = this.querySelector(`#pane${pageId}`);

        if (nav === null) {
            nav = this.createNavigation(pageId, className);
        }
        else {
            nav.classList.add(className);
        }
    }

    handleKeyup = (e) => {
        if (e.key === "Escape") {
            this.hide();
        }
    }

    handleClickOutside = (e) => {

        if (e.target === this.opener)
            return;

        if (e.target.closest(".global-navigation-panel") === null)
            this.hide();
    }

    createNavigation(pageId, className) {
        const nav = document.createElement("context-pane");
        nav.setAttribute("id", `pane${pageId}`);
        nav.setAttribute("data-page-id", pageId);

        if (className) {
            nav.classList.add(className);
        }

        this.body.appendChild(nav);

        return nav;
    }

    toggle = (e) => {
        if (this.isOpen) {
            this.hide();
        }
        else {
            this.show();
        }
    }


    show = (e) => {
        this.opener.setAttribute("aria-expanded", "true");
        this.classList.add("global-navigation-open");

        if (this.querySelector(`[data-page-id=\"${this.startId}\"`) == null) {
            this.createNavigation(this.startId, "current");
        }
    }

    hide = (e) => {
        this.opener.setAttribute("aria-expanded", "false");
        this.classList.remove("global-navigation-open");
    }

    get body() {
        return this.querySelector(".global-navigation-body");
    }

    get isOpen() {
        return this.classList.contains("global-navigation-open");
    }

    get opener() {
        return document.querySelector("[data-app-toggle=global-navigation]");
    }

    get startId() {
        return this.dataset.startId;
    }



}

customElements.define('global-navigation', GlobalNavigation, { extends: 'div' });